import { chartColors } from './chart-colors';
import { tooltipFormatter } from './tooltip/tooltip-helper';

export default {
    chart: {
        backgroundColor: 'var(--palette-gray-0)',
        style: {
            fontFamily: 'Inter',
        },
        spacingTop: 20,
        spacingLeft: 0,
    },
    colors: chartColors,
    credits: {
        enabled: false,
    },
    legend: {
        enabled: false,
    },
    loading: {
        style: {
            backgroundColor: 'var(--palette-gray-0)',
        },
    },
    plotOptions: {
        series: {
            marker: {
                symbol: 'circle',
            },
            states: {
                'inactive': {
                    opacity: 1,
                },
                'inactive-fade': {
                    animation: {
                        duration: 150,
                    },
                    opacity: 0.2,
                },
                'normal': {
                    animation: {
                        duration: 150,
                    },
                },
            },
            minPointLength: 1,
        },
        pie: {
            center: ['50%', '50%'],
        },
        area: {
            fillOpacity: 0.5,
        },
    },
    series: [],
    subtitle: {
        text: null,
    },
    title: {
        text: null,
    },
    tooltip: {
        className: 'chart-tooltip',
        formatter: tooltipFormatter,
        padding: 0,
        shadow: {
            color: 'rgba(var(--raw-palette-gray-100), 0.07)',
            width: 12,
        },
        useHTML: true,
        backgroundColor: 'var(--palette-gray-0)',
        style: {
            color: 'var(--palette-gray-90)',
        },
    },
    xAxis: [
        {
            type: 'datetime',
            tickPixelInterval: 200,
            tickLength: 0,
            startOfWeek: 0,
            dateTimeLabelFormats: {
                day: '%b %e',
                week: '%b %e',
                month: '%b %Y',
            },
            gridLineColor: 'var(--palette-gray-40)',
            lineColor: 'var(--palette-gray-40)',
            labels: {
                style: {
                    color: 'var(--palette-gray-100)',
                    opacity: 0.8,
                },
            },
            title: {
                style: {
                    color: 'var(--palette-gray-100)',
                },
            },
        },
    ],
    yAxis: [
        {
            min: 0,
            title: {
                text: null,
                style: {
                    color: 'var(--palette-gray-100)',
                },
            },
            gridLineColor: 'var(--palette-gray-40)',
            labels: {
                align: 'right',
                style: {
                    color: 'var(--palette-gray-100)',
                    opacity: 0.8,
                },
            },
            tickPixelInterval: 92,
            allowDecimals: false,
            softMax: 1,
            max: undefined,
        },
        {
            min: 0,
            title: {
                text: null,
                style: {
                    color: 'var(--palette-gray-100)',
                },
            },
            gridLineColor: 'var(--palette-gray-40)',
            labels: {
                align: 'left',
                style: {
                    color: 'var(--palette-gray-100)',
                    opacity: 0.8,
                },
            },
            linkedTo: undefined,
            tickPixelInterval: 92,
            allowDecimals: false,
            softMax: 1,
        },
    ],
};
